<template>
  <div class="combobox-purchase-item-info">
    <div class="float-right w-fit pl-1 text-right">
      <span class="line-through" v-if="hasCustomUnitPrice && agreedUnitPrice">
        {{ normalizeCurrency(Number(agreedUnitPrice)) }}
      </span>
      <span :class="{ 'text-warning': !unitPrice }">{{ unitPriceText }}</span>
    </div>
    <div class="space-x-1">
      <FontAwesomeIcon :icon="['fas', 'cart-shopping']" class="text-red-800" title="Inkoop" />
      <span class="inline-block font-bold!">Inkoop:</span>
      <span>{{ item.name }} {{ item.getUnitName() }} {{ item.supplier.name }} </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { PurchaseItem } from "@/models/purchase-item.model"
import { normalizeCurrency } from "@/helper/number-helper"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import usePriceAgreements from "@/composables/administration/price-agreements"
import type { Project } from "@/models/project.model"

const props = defineProps<{
  item: PurchaseItem
  unitPrice: string | undefined
  project?: Project
  hasCustomUnitPrice?: boolean
}>()

defineOptions({
  inheritAttrs: false
})

const { unitPrice: agreedUnitPrice } = usePriceAgreements(
  computed(() => props.project),
  props.item
)
const unitPriceText = computed(() => {
  return props.unitPrice ? normalizeCurrency(Number(props.unitPrice)) : "???"
})
</script>

<style scoped></style>
